export default __webpack_public_path__ + "static/media/Mulish-Bold.6cb68186.ttf";